import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
    static values = { unitId: String };
    declare readonly unitIdValue: string;

    unitIdValueChanged(): void {
        this.element.closest("#property-management-shell")
            ?.querySelectorAll<HTMLElement>("[data-property-row-id]")
            .forEach(row => row.setAttribute("aria-current", String(row.dataset.propertyRowId === this.unitIdValue)));
    }
}
